<div class="container">
    <h1><strong>Resume</strong></h1>
    <span class="bar-title mb-5"></span>
    <div class="row">
        <div class="col-lg-4 col-md-12 col-sm-12 " data-aos="fade-right">

            <picture>
                <img src="assets/images/mifdha.jpg" alt="profile photo" class="img-fluid">
            </picture>

        </div>
        <div class="col-lg-8  col-md-12 col-sm-12 pt-4 pt-lg-0" data-aos="fade-left">
            <h3>About Me</h3>
            <p class="content">
              I am a talented, hardworking and tech-enthusiastic individual, open-minded about learning new things
              and working on problematic areas, passionate about effectively collaborating and committing in a
              corporate environment and striving to do a quality job of any task assigned.

            </p>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li>
                            <fa-icon [icon]="mapMarker"></fa-icon><strong>Mawanella, Sri Lanka</strong>
                        </li>

                        <li>
                            <fa-icon [icon]="email"></fa-icon><strong><a href="mailto:mifmilan@gmail.com">
                                    mifmilan@gmail.com</a></strong>
                        </li>

                    </ul>
                </div>
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li>
                            <fa-icon [icon]="mobile"></fa-icon><strong> +94 76 279 7566</strong>
                        </li>
                        <li>
                            <fa-icon [icon]="badge"></fa-icon><strong>B.Sc.(Hons.) in Information
                                Technology</strong>
                        </li>

                    </ul>
                </div>
            </div>
            <p class="content">
                I am looking for an innovative and user-centered company to best meet customer needs, from their
                idea to the final delivery of their project,
                or to participate in the improvement of an existing project.
            </p>
            <div class="button" >
                    <button type="button" class="btn btn-primary mr-3" (click)="downloadPdf()">Download CV</button>
            </div>
        </div>
    </div>
</div>
